/**
 * Feature-Bundle-Convention (Convention-over-Configuration):
 *
 *   - Ein Feature-Key der auf '.enabled' endet ist ein Bundle-Master.
 *   - Sein Namespace-Prefix (alles vor '.enabled' inkl. trailing dot) gruppiert
 *     alle Bundle-Children.
 *   - Features ohne '.enabled'-Suffix oder ohne Master mit passendem Prefix
 *     bleiben unbundled (flach rendern wie bisher).
 *
 * Pures Funktions-Modul ohne React-Deps. ESM-Export passend zum
 * `"type":"module"` des Frontends. Test-Pfad liegt in
 * kontor/backend/__tests__/featureBundles.test.js mit inline-Kopie der
 * Logik — Backend ist CJS und kann diese ESM-Datei nicht direkt laden.
 */
export function groupFeaturesIntoBundles(features) {
  const list = Array.isArray(features) ? features : [];
  const masters = list.filter(f => f && typeof f.key === 'string' && /\.enabled$/.test(f.key));
  const bundles = masters.map(m => {
    const prefix = m.key.slice(0, -'.enabled'.length) + '.';
    return {
      master: m,
      prefix,
      children: list.filter(c => c !== m && typeof c.key === 'string'
                                  && c.key !== m.key
                                  && c.key.startsWith(prefix))
    };
  });
  const claimed = new Set(bundles.flatMap(b => [b.master.key, ...b.children.map(c => c.key)]));
  const unbundled = list.filter(f => f && !claimed.has(f.key));
  return { bundles, unbundled };
}
